import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-[#141414] flex flex-col">
      <Header />
      <div className="flex-1 container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-2">
          Conditions d'Utilisation – H4KIG STREAM
        </h1>
        <p className="text-gray-400 text-sm mb-10">
          Version en vigueur au 31 janvier 2026
        </p>

        <div className="prose prose-invert prose-lg max-w-none space-y-6 text-gray-300">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">1. Acceptation des conditions</h2>
            <p>
              En accédant à H4KIG STREAM ou en utilisant ses services (ci-après le « Service »), vous acceptez d'être lié par les présentes Conditions d'Utilisation et notre Politique de Confidentialité. Si vous n'acceptez pas, n'utilisez pas le Service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">2. Description du Service</h2>
            <p>
              H4KIG STREAM est une plateforme de streaming proposant un catalogue sélectionné de films, séries et autres contenus audiovisuels. Le catalogue est géré et mis en ligne exclusivement par l'exploitant du Service. Les utilisateurs peuvent uniquement visionner les contenus disponibles, sans possibilité d'uploader, de publier ou de modifier quoi que ce soit.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">3. Utilisation autorisée</h2>
            <p>
              Vous pouvez utiliser le Service pour un usage personnel et non commercial, dans le respect des lois applicables et des limitations de votre abonnement (si applicable).
            </p>
            <p>
              Le Service est destiné exclusivement au visionnage privé au sein de votre foyer.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">4. Interdictions</h2>
            <p>Il est strictement interdit de :</p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>tenter d'uploader, poster, transmettre, partager ou rendre disponible tout contenu (vidéo, audio, texte, etc.) sur le Service ;</li>
              <li>copier, télécharger, reproduire, distribuer, modifier, diffuser publiquement, performer, revendre ou exploiter commercialement les contenus du catalogue ;</li>
              <li>contourner les protections techniques, géo-restrictions, DRM ou mesures anti-copie ;</li>
              <li>utiliser des bots, scrapers, outils automatisés pour extraire des données ou surcharger le Service ;</li>
              <li>utiliser le Service pour des projections publiques, événements commerciaux ou toute forme de diffusion non autorisée ;</li>
              <li>tenter de reverse-engineer, décompiler ou altérer le Service de quelque manière que ce soit.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">5. Contenus du catalogue</h2>
            <p>
              Tous les contenus sont sélectionnés et mis en ligne par H4KIG STREAM. Nous nous efforçons de respecter les droits d'auteur et licences applicables. Cependant, vous êtes responsable de l'usage que vous faites des contenus visionnés (conformément aux lois sur le copyright de votre pays). H4KIG STREAM décline toute responsabilité en cas d'usage illicite par l'utilisateur.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">6. Comptes et sécurité</h2>
            <p>
              L'accès peut nécessiter un compte. Vous devez fournir des informations exactes et sécuriser vos identifiants. H4KIG STREAM peut suspendre ou résilier tout compte en cas de violation.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">7. Propriété intellectuelle</h2>
            <p>
              Le Service, son interface, son nom, et l'ensemble des contenus du catalogue restent la propriété exclusive de H4KIG ou de ses concédants. Aucune licence n'est accordée au-delà du droit limité de visionnage personnel pendant la durée d'accès autorisée.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">8. Limitation de responsabilité</h2>
            <p>
              Le Service est fourni « en l'état » sans garantie expresse ou implicite. H4KIG STREAM ne pourra être tenu responsable de dommages directs, indirects, consécutifs, perte de données, interruption, etc., liés à l'utilisation du Service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">9. Modifications et résiliation</h2>
            <p>
              Nous pouvons modifier ces conditions à tout moment (publication de la nouvelle version). La poursuite d'utilisation vaut acceptation. Nous pouvons suspendre ou arrêter le Service ou votre accès sans préavis en cas de violation.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">10. Contactez-nous</h2>
            <p>
              <a href="mailto:support@h4kig.us" className="text-white hover:text-blue-400 transition">support@h4kig.us</a> | Telegram : <a href="https://t.me/H4KIG" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 transition">@H4KIG</a>
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfService;
